import { loincCoding } from '#src/models/loinc.ts'
import { PHQ_FREQUENCY_ANSWERS } from '#src/terminology/instruments/instrumentTerminology.ts'
import { PHQ_COPYRIGHT } from '#src/terminology/instruments/phq9.ts'
import {
  scoreBand,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const SECTIONS: InstrumentSection[] = [
  {
    id: 'items',
    items: [
      ['44250-9', 'Little interest or pleasure in doing things'],
      ['44255-8', 'Feeling down, depressed, or hopeless'],
    ].map(([code, label]) =>
      scoredItem(loincCoding(code, label), PHQ_FREQUENCY_ANSWERS)
    ),
  },
]

export const PHQ2_TEMPLATE: InstrumentTemplate = {
  id: 'phq-2',
  version: '1',
  panel: loincCoding(
    '55757-9',
    'Patient Health Questionnaire 2 item (PHQ-2) [Reported]'
  ),
  title: 'Patient Health Questionnaire-2 (PHQ-2)',
  copyright: PHQ_COPYRIGHT,
  reference:
    'https://aidsetc.org/sites/default/files/resources_files/PHQ-2_English.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'phq-2',
    coding: loincCoding(
      '55758-7',
      'Patient Health Questionnaire 2 item (PHQ-2) total score'
    ),
    sections: SECTIONS,
    completeness: { requireAll: true },
    bands: [
      scoreBand(
        { min: 0, max: 2 },
        'phq-2-negative',
        'Screen Negative',
        'green'
      ),
      scoreBand(
        { min: 3 },
        'phq-2-positive',
        'Screen Positive (Major Depressive Disorder Likely)',
        'red'
      ),
    ],
  }),
}
